import { Box, Divider, Stack, Text } from '@mantine/core';
import moment from 'moment';

import { EnvironmentCountries, ExitControlResult } from '@e-origin/shared';

import { useSettings } from '@hooks/useSettings';
import classes from './ExitControlResult.module.css';

interface ExitControlResultNotificationProps {
  exitControlResults: ExitControlResult[];
}

export const ExitControlResultNotification: React.FC<ExitControlResultNotificationProps> = ({ exitControlResults }) => {
  const { data: settings } = useSettings();

  return (
    <>
      <Divider mb="md" />

      <Stack py={20}>
        <Text className={classes.sectionTitle}>Exit Control Result</Text>
        {exitControlResults.map((exitControlResult) => (
          <Box className={classes.row}>
            <div>
              <label>Code</label>
              <p>{exitControlResult.code}</p>
            </div>
            <div>
              <label>Exit date</label>
              <p>{exitControlResult.exitDate}</p>
            </div>
            {settings?.country === EnvironmentCountries.NL && (
              <div>
                <label>Exit control results</label>
                <p>{exitControlResult?.statement === '1' ? 'OK' : 'Not OK'}</p>
              </div>
            )}
          </Box>
        ))}
      </Stack>
    </>
  );
};
